import * as React from "react";
import { Container, Col, Row } from 'react-bootstrap';
import { StaticImage } from "gatsby-plugin-image";

import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import LazyLoad from "react-lazy-load";

const Awards = ({
  title = "Awards, accolades, recognition<br /><span class='text-muted'>received by</span> <span class='text-primary'>Peerbits</span>",
  description = "Over the years, we have helped countless startups and enterprises by providing them with virtual development centre that has produced some top-notch solutions. Our continuous high-class work has also received many awards and recognition which are shown below.",
  sectionClass = ''
}) => {

  const Logo1 = '../images/award-partner-certification/clutch.png';
  const Logo3 = '../images/award-partner-certification/siliconindia.png';
  const Logo4 = '../images/award-partner-certification/goodfirms.png';
  const Logo13 = '../images/award-partner-certification/app-futura.png';
  const Logo18 = '../images/award-partner-certification/extract.png';
  const Logo19 = '../images/award-partner-certification/top-app.png';
  const Logo2 = '../images/award-partner-certification/forbes.png';
  // const Logo5 = '../images/award-partner-certification/gesia.png';
  // const Logo6 = '../images/award-partner-certification/cmmi.png';
  // const Logo7 = '../images/award-partner-certification/nasscom.png';
  // const Logo8 = '../images/award-partner-certification/iso-9001.png';
  // const Logo14 = '../images/award-partner-certification/iso-27001.png';
  // const Logo9 = '../images/award-partner-certification/aws.png';
  // const Logo10 = '../images/award-partner-certification/elasticsearch.png';
  // const Logo11 = '../images/award-partner-certification/microsoft.png';
  // const Logo12 = '../images/award-partner-certification/mongo-db.png';

  const Logo15 = '../images/award-partner-certification/clutch-1.png';
  const Logo16 = '../images/award-partner-certification/clutch-2.png';
  const Logo17 = '../images/award-partner-certification/goodfirms-1.png';

  return (
    <>

      <section className={`section ${sectionClass}`}>
        <Container className="py-5">
          <div className="max-width-950 mb-5 pb-1 d-flex0 flex-wrap0 justify-content-between0">
            {/* <div> */}
            <h2 className="mb-4" dangerouslySetInnerHTML={{ __html: title }} />
            <p className="lead">{description}</p>
            {/* </div> */}
            {/* <div className="dark-box-1 text-center p-lg-5">
              <div className="d4_Bl">
                <p className="h4 mb-0">28 Reviews on Clutch</p>
                <div className="d-flex align-items-center justify-content-center">
                  <svg id="big-black-clutch" viewBox="0 0 75 85" width="57px" height="64px">
                    <g fill="none" fill-rule="evenodd">
                      <g fill="#202020" fill-rule="nonzero">
                        <g transform="translate(-1052 -1073) translate(188 1010) translate(864 63)">
                          <path d="M58.547 60.238C54.1 64.18 48.349 66.32 42.415 66.24c-13.676 0-23.718-10.075-23.718-23.9 0-13.826 9.722-23.472 23.718-23.472 5.947-.081 11.72 2.014 16.239 5.894l2.991 2.573 13.248-13.29-3.312-3.109C63.568 3.754 53.16-.147 42.415.004 17.842.004 0 17.796 0 42.232 0 66.67 18.27 84.996 42.415 84.996c10.846.146 21.344-3.837 29.38-11.146L75 70.849l-13.462-13.29-2.991 2.68z"></path>
                          <ellipse cx="42" cy="42.5" rx="14" ry="14.5"></ellipse>
                        </g>
                      </g>
                    </g>
                  </svg>
                  <p className="font-size-64 text-dark fw-medium mb-0 ms-4">4.7</p>
                </div>
              </div>
              <svg className="h6_5q" id="star-x5" viewBox="0 0 238 32" width="238px" height="32px">
                <g fill="none" fill-rule="evenodd">
                  <g fill="#30b254" fill-rule="nonzero">
                    <path d="M17.804.527l4.325 10.102 11.072.94c.768.065 1.08 1.01.497 1.508L25.3 20.258l2.516 10.683c.175.743-.64 1.326-1.3.932l-9.515-5.664-9.515 5.664c-.662.393-1.475-.191-1.3-.932l2.516-10.683-8.4-7.183C-.28 12.578.03 11.632.8 11.567l11.072-.94 4.325-10.1c.3-.703 1.307-.703 1.607 0zM69.28.527l4.198 10.102 10.746.94c.745.065 1.049 1.01.483 1.508l-8.151 7.181 2.442 10.683c.17.743-.621 1.326-1.262.932l-9.235-5.664-9.235 5.664c-.642.393-1.432-.191-1.262-.932l2.442-10.683-8.152-7.183c-.566-.497-.265-1.443.482-1.508l10.747-.94L67.72.528c.292-.703 1.269-.703 1.56 0zM119.804.527l4.325 10.102 11.072.94c.768.065 1.08 1.01.497 1.508l-8.398 7.181 2.516 10.683c.175.743-.64 1.326-1.3.932l-9.515-5.664-9.515 5.664c-.662.393-1.475-.191-1.3-.932l2.516-10.683-8.4-7.183c-.582-.497-.272-1.443.498-1.508l11.072-.94 4.325-10.1c.3-.703 1.307-.703 1.607 0zM171.328.527l4.452 10.102 11.397.94c.79.065 1.112 1.01.512 1.508l-8.645 7.181 2.59 10.683c.18.743-.659 1.326-1.338.932l-9.795-5.664-9.795 5.664c-.68.393-1.518-.191-1.338-.932l2.59-10.683-8.647-7.183c-.6-.497-.28-1.443.512-1.508l11.398-.94 4.452-10.1c.309-.703 1.346-.703 1.655 0zM221.804.527l4.325 10.102 11.072.94c.768.065 1.08 1.01.497 1.508l-8.398 7.181 2.516 10.683c.175.743-.64 1.326-1.3.932l-9.515-5.664-9.515 5.664c-.662.393-1.475-.191-1.3-.932l2.516-10.683-8.4-7.183c-.582-.497-.272-1.443.498-1.508l11.072-.94 4.325-10.1c.3-.703 1.307-.703 1.607 0z" transform="translate(-1057 -1188) translate(188 1010) translate(864 63) translate(5 115)"></path>
                  </g>
                </g>
              </svg>
            </div> */}
          </div>

          <div className="d-none d-lg-block">
            {/* <div className="mb-5">
              <h3 className="mb-4">Our accreditations: Certified for excellence</h3>
              <Row className="g-4 award-partner-certification align-items-center0" xs={2} sm={2} md={4} lg={4} xl={5}>
                <Col>
                  <div className="equal-height logo-5">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo5} alt="Award Partner Certification Logo" />
                  </div>
                </Col>
                <Col>
                  <div className="equal-height logo-6">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo6} alt="Award Partner Certification Logo" />
                  </div>
                </Col>
                <Col>
                  <div className="equal-height logo-7">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo7} alt="Award Partner Certification Logo" />
                  </div>
                </Col>
                <Col>
                  <div className="equal-height logo-8">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo8} alt="Award Partner Certification Logo" />
                  </div>
                </Col>
                <Col>
                  <div className="equal-height logo-14">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo14} alt="Award Partner Certification Logo" />
                  </div>
                </Col>
              </Row>
            </div>
            <div className="mb-5">
              <h3 className="mb-4">Our partnerships: Strong alliances, stronger impact</h3>
              <Row className="g-4 award-partner-certification align-items-center0" xs={2} sm={2} md={4} lg={4} xl={5}>
                <Col>
                  <div className="equal-height logo-9">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo9} alt="Award Partner Certification Logo" />
                  </div>
                </Col>
                <Col>
                  <div className="equal-height logo-10">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo10} alt="Award Partner Certification Logo" />
                  </div>
                </Col>
                <Col>
                  <div className="equal-height logo-11">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo11} alt="Award Partner Certification Logo" />
                  </div>
                </Col>
                <Col>
                  <div className="equal-height logo-12">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo12} alt="Award Partner Certification Logo" />
                  </div>
                </Col>
              </Row>
            </div> */}
            <div className="mb-0">
              {/* <h3 className="mb-4">Our awards: Shining bright with determination</h3> */}
              <Row className="g-4 award-partner-certification align-items-center0" xs={2} sm={2} md={4} lg={4} xl={5}>
                <Col>
                  <div className="equal-height logo-1">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo1} alt="Award Partner Certification Logo" />
                  </div>
                </Col>
                <Col>
                  <div className="equal-height logo-3">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo3} alt="Award Partner Certification Logo" />
                  </div>
                </Col>
                <Col>
                  <div className="equal-height logo-4">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo4} alt="Award Partner Certification Logo" />
                  </div>
                </Col>
                <Col>
                  <div className="equal-height logo-13">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo13} alt="Award Partner Certification Logo" />
                  </div>
                </Col>
                <Col>
                  <div className="equal-height logo-18">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo18} alt="Award Partner Certification Logo" />
                  </div>
                </Col>
                <Col>
                  <div className="equal-height logo-2">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo2} alt="Award Partner Certification Logo" />
                  </div>
                </Col>
                <Col>
                  <div className="equal-height logo-15">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo15} alt="Award Partner Certification Logo" />
                  </div>
                </Col>
                <Col>
                  <div className="equal-height logo-16">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo16} alt="Award Partner Certification Logo" />
                  </div>
                </Col>
                <Col>
                  <div className="equal-height logo-17">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo17} alt="Award Partner Certification Logo" />
                  </div>
                </Col>
                <Col>
                  <div className="equal-height logo-19">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo19} alt="Award Partner Certification Logo" />
                  </div>
                </Col>
              </Row>
            </div>
          </div>

          <div className="d-block d-lg-none">
            {/* <div className="mb-5">
              <h3 className="mb-4">Our accreditations: Certified for excellence</h3>
              <LazyLoad>

                <Swiper
                  modules={[Navigation, Pagination, Autoplay]}
                  slidesPerView={1}
                  navigation={false}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                  }}
                  breakpoints={{
                    0: {
                      slidesPerView: 2,
                      spaceBetween: 30,
                    },
                  }}
                  className="award-partner-certification"
                >
                  <SwiperSlide>
                    <div className="equal-height logo-5">
                      <StaticImage loading="lazy" width={240} height={120} src={Logo5} alt="Award Partner Certification Logo" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="equal-height logo-6">
                      <StaticImage loading="lazy" width={240} height={120} src={Logo6} alt="Award Partner Certification Logo" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="equal-height logo-7">
                      <StaticImage loading="lazy" width={240} height={120} src={Logo7} alt="Award Partner Certification Logo" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="equal-height logo-8">
                      <StaticImage loading="lazy" width={240} height={120} src={Logo8} alt="Award Partner Certification Logo" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="equal-height logo-14">
                      <StaticImage loading="lazy" width={240} height={120} src={Logo14} alt="Award Partner Certification Logo" />
                    </div>
                  </SwiperSlide>

                </Swiper>
              </LazyLoad>
            </div>
            <div className="mb-5">
              <h3 className="mb-4">Our partnerships: Strong alliances, stronger impact</h3>
              <LazyLoad>
                <Swiper
                  modules={[Navigation, Pagination, Autoplay]}
                  slidesPerView={1}
                  navigation={false}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                  }}
                  breakpoints={{
                    0: {
                      slidesPerView: 2,
                      spaceBetween: 30,
                    },
                  }}
                  className="award-partner-certification"
                >
                  <SwiperSlide>
                    <div className="equal-height logo-9">
                      <StaticImage loading="lazy" width={240} height={120} src={Logo9} alt="Award Partner Certification Logo" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="equal-height logo-10">
                      <StaticImage loading="lazy" width={240} height={120} src={Logo10} alt="Award Partner Certification Logo" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="equal-height logo-11">
                      <StaticImage loading="lazy" width={240} height={120} src={Logo11} alt="Award Partner Certification Logo" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="equal-height logo-12">
                      <StaticImage loading="lazy" width={240} height={120} src={Logo12} alt="Award Partner Certification Logo" />
                    </div>
                  </SwiperSlide>

                </Swiper>
              </LazyLoad>
            </div> */}
            <div className="mb-0">
              {/* <h3 className="mb-4">Our awards: Shining bright with determination</h3> */}
              <LazyLoad>
                <Swiper
                  modules={[Navigation, Pagination, Autoplay]}
                  slidesPerView={1}
                  navigation={false}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                  }}
                  breakpoints={{
                    0: {
                      slidesPerView: 2,
                      spaceBetween: 30,
                    },
                  }}
                  className="award-partner-certification"
                >
                  <SwiperSlide>
                    <div className="equal-height logo-1">
                      <StaticImage loading="lazy" width={240} height={120} src={Logo1} alt="Award Partner Certification Logo" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="equal-height logo-3">
                      <StaticImage loading="lazy" width={240} height={120} src={Logo3} alt="Award Partner Certification Logo" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="equal-height logo-4">
                      <StaticImage loading="lazy" width={240} height={120} src={Logo4} alt="Award Partner Certification Logo" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="equal-height logo-13">
                      <StaticImage loading="lazy" width={240} height={120} src={Logo13} alt="Award Partner Certification Logo" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="equal-height logo-18">
                      <StaticImage loading="lazy" width={240} height={120} src={Logo18} alt="Award Partner Certification Logo" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="equal-height logo-2">
                      <StaticImage loading="lazy" width={240} height={120} src={Logo2} alt="Award Partner Certification Logo" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="equal-height logo-15">
                      <StaticImage loading="lazy" width={240} height={120} src={Logo15} alt="Award Partner Certification Logo" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="equal-height logo-16">
                      <StaticImage loading="lazy" width={240} height={120} src={Logo16} alt="Award Partner Certification Logo" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="equal-height logo-17">
                      <StaticImage loading="lazy" width={240} height={120} src={Logo17} alt="Award Partner Certification Logo" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="equal-height logo-19">
                      <StaticImage loading="lazy" width={240} height={120} src={Logo19} alt="Award Partner Certification Logo" />
                    </div>
                  </SwiperSlide>
                </Swiper>
              </LazyLoad>
            </div>
          </div>

          {/* <div className="d-none d-lg-block">
            <Row className="g-4 award-partner-certification align-items-center0" xs={2} sm={2} md={4} lg={4} xl={5}>
              <Col>
                <div className="equal-height logo-5">
                  <StaticImage loading="lazy" width={240} height={120} src={Logo5} alt="Award Partner Certification Logo" />
                </div>
              </Col>
              <Col>
                <div className="equal-height logo-6">
                  <StaticImage loading="lazy" width={240} height={120} src={Logo6} alt="Award Partner Certification Logo" />
                </div>
              </Col>
              <Col>
                <div className="equal-height logo-7">
                  <StaticImage loading="lazy" width={240} height={120} src={Logo7} alt="Award Partner Certification Logo" />
                </div>
              </Col>
              <Col>
                <div className="equal-height logo-8">
                  <StaticImage loading="lazy" width={240} height={120} src={Logo8} alt="Award Partner Certification Logo" />
                </div>
              </Col>
              <Col>
                <div className="equal-height logo-14">
                  <StaticImage loading="lazy" width={240} height={120} src={Logo14} alt="Award Partner Certification Logo" />
                </div>
              </Col>
              <Col>
                <div className="equal-height logo-1">
                  <StaticImage loading="lazy" width={240} height={120} src={Logo1} alt="Award Partner Certification Logo" />
                </div>
              </Col>
              <Col>
                <div className="equal-height logo-3">
                  <StaticImage loading="lazy" width={240} height={120} src={Logo3} alt="Award Partner Certification Logo" />
                </div>
              </Col>
              <Col>
                <div className="equal-height logo-4">
                  <StaticImage loading="lazy" width={240} height={120} src={Logo4} alt="Award Partner Certification Logo" />
                </div>
              </Col>
              <Col>
                <div className="equal-height logo-13">
                  <StaticImage loading="lazy" width={240} height={120} src={Logo13} alt="Award Partner Certification Logo" />
                </div>
              </Col>
              <Col>
                <div className="equal-height logo-18">
                  <StaticImage loading="lazy" width={240} height={120} src={Logo18} alt="Award Partner Certification Logo" />
                </div>
              </Col>
              <Col>
                <div className="equal-height logo-9">
                  <StaticImage loading="lazy" width={240} height={120} src={Logo9} alt="Award Partner Certification Logo" />
                </div>
              </Col>
              <Col>
                <div className="equal-height logo-10">
                  <StaticImage loading="lazy" width={240} height={120} src={Logo10} alt="Award Partner Certification Logo" />
                </div>
              </Col>
              <Col>
                <div className="equal-height logo-11">
                  <StaticImage loading="lazy" width={240} height={120} src={Logo11} alt="Award Partner Certification Logo" />
                </div>
              </Col>
              <Col>
                <div className="equal-height logo-12">
                  <StaticImage loading="lazy" width={240} height={120} src={Logo12} alt="Award Partner Certification Logo" />
                </div>
              </Col>
              <Col>
                <div className="equal-height logo-2">
                  <StaticImage loading="lazy" width={240} height={120} src={Logo2} alt="Award Partner Certification Logo" />
                </div>
              </Col>
              <Col>
                <div className="equal-height logo-15">
                  <StaticImage loading="lazy" width={240} height={120} src={Logo15} alt="Award Partner Certification Logo" />
                </div>
              </Col>
              <Col>
                <div className="equal-height logo-16">
                  <StaticImage loading="lazy" width={240} height={120} src={Logo16} alt="Award Partner Certification Logo" />
                </div>
              </Col>
              <Col>
                <div className="equal-height logo-17">
                  <StaticImage loading="lazy" width={240} height={120} src={Logo17} alt="Award Partner Certification Logo" />
                </div>
              </Col>
              <Col>
                <div className="equal-height logo-19">
                  <StaticImage loading="lazy" width={240} height={120} src={Logo19} alt="Award Partner Certification Logo" />
                </div>
              </Col>
            </Row>
          </div> */}
          {/* <div className="d-block d-lg-none">
            <LazyLoad>
              <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                slidesPerView={1}
                navigation={false}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                breakpoints={{
                  0: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                  },
                }}
                className="award-partner-certification"
              >
                <SwiperSlide>
                  <div className="equal-height logo-5">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo5} alt="Award Partner Certification Logo" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="equal-height logo-6">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo6} alt="Award Partner Certification Logo" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="equal-height logo-7">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo7} alt="Award Partner Certification Logo" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="equal-height logo-8">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo8} alt="Award Partner Certification Logo" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="equal-height logo-14">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo14} alt="Award Partner Certification Logo" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="equal-height logo-1">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo1} alt="Award Partner Certification Logo" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="equal-height logo-3">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo3} alt="Award Partner Certification Logo" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="equal-height logo-4">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo4} alt="Award Partner Certification Logo" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="equal-height logo-13">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo13} alt="Award Partner Certification Logo" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="equal-height logo-18">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo18} alt="Award Partner Certification Logo" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="equal-height logo-9">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo9} alt="Award Partner Certification Logo" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="equal-height logo-10">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo10} alt="Award Partner Certification Logo" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="equal-height logo-11">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo11} alt="Award Partner Certification Logo" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="equal-height logo-12">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo12} alt="Award Partner Certification Logo" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="equal-height logo-2">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo2} alt="Award Partner Certification Logo" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="equal-height logo-15">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo15} alt="Award Partner Certification Logo" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="equal-height logo-16">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo16} alt="Award Partner Certification Logo" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="equal-height logo-17">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo17} alt="Award Partner Certification Logo" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="equal-height logo-19">
                    <StaticImage loading="lazy" width={240} height={120} src={Logo19} alt="Award Partner Certification Logo" />
                  </div>
                </SwiperSlide>
              </Swiper>
            </LazyLoad>
          </div> */}
        </Container>
      </section >
    </>
  )

}

export default Awards;
